import React from 'react';

type SupportArticleInlineProps = {
  text: string;
};

const INLINE_TOKEN_PATTERN = /(\*\*[^*\n]+\*\*|\[[^\]\n]+\]\((?:https?:\/\/|mailto:)[^)]+\)|`[^`\n]+`)/gi;
const LINK_TOKEN_PATTERN = /^\[([^\]]+)\]\(((?:https?:\/\/|mailto:)[^)]+)\)$/i;

const SupportArticleInline: React.FC<SupportArticleInlineProps> = ({ text }) => (
  <>
    {text.split(INLINE_TOKEN_PATTERN).filter(Boolean).map((token, index) => {
      if (token.startsWith('**') && token.endsWith('**')) {
        return <strong key={`strong-${index}`}>{token.slice(2, -2)}</strong>;
      }

      if (token.startsWith('`') && token.endsWith('`')) {
        return <code key={`code-${index}`}>{token.slice(1, -1)}</code>;
      }

      const linkMatch = token.match(LINK_TOKEN_PATTERN);
      if (linkMatch) {
        return (
          <a
            key={`link-${index}`}
            href={linkMatch[2]}
            target="_blank"
            rel="noopener noreferrer"
          >
            {linkMatch[1]}
          </a>
        );
      }

      return <React.Fragment key={`text-${index}`}>{token}</React.Fragment>;
    })}
  </>
);

export default SupportArticleInline;
